import AccessStateCard from "./access-state-card";

// The access states from "States the client must handle". Each is display-only.

export const AccessExpiredState = (props: {
  endedOn?: string;
  tenantName?: string;
  isGuest: boolean;
}) => {
  const { endedOn, tenantName, isGuest } = props;
  const access = isGuest ? "guest access" : "access";

  return (
    <AccessStateCard
      icon="schedule"
      tone="warning"
      badge={`${access} expired`}
      title={
        endedOn ? `Your ${access} ended on ${endedOn}` : `Your ${access} ended`
      }
      description={`Your ${
        isGuest ? "temporary " : ""
      }access to ${tenantName || "this organization"} has expired. Request an extension from an organization administrator to continue.`}
    />
  );
};

export const NoAccessAssignedState = () => (
  <AccessStateCard
    icon="person_off"
    tone="info"
    badge="No access assigned"
    title="No access has been assigned yet"
    description="Your account is set up, but no organization, branch, or site grants have been shared with you. An administrator needs to add your first grant."
  />
);

export const RoleRestrictionState = (props: { roleLabel?: string }) => (
  <AccessStateCard
    icon="gpp_maybe"
    tone="info"
    badge="Role restriction"
    title="Your role can't open this management area"
    description={`Roles & Access is limited to organization administrators. ${
      props.roleLabel ? `Your ${props.roleLabel} role` : "Your role"
    } can continue to use day-to-day site tools.`}
  />
);

// Shown when current/access couldn't be loaded: without it nothing gated may render.
export const AccessUnavailableState = (props: { message?: string }) => (
  <AccessStateCard
    icon="error"
    tone="danger"
    badge="Access unavailable"
    title="We couldn't confirm your access"
    description={
      props.message ||
      "Your access details couldn't be loaded. Refresh the page to try again."
    }
  />
);

export const SiteAccessRequiredState = (props: { siteName?: string }) => (
  <AccessStateCard
    icon="lock"
    tone="danger"
    badge="Access required"
    title="You don't have access to this site"
    description={`Your account is active, but ${
      props.siteName || "this site"
    } isn't included in your current access. You can keep working in the sites already assigned to you.`}
  />
);
